<template>
  <div class="scrollable-content--width">
    <section>
      <div class="section-content">
        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows a terminated employee to select
              partial distributions?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.partial_distributions_yesno">
              <roe-radio-input
                v-model="formData.partial_distributions_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows a terminated employee to select
              installment payments?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.installment_payments_yesno">
              <roe-radio-input
                v-model="formData.installment_payments_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate if the plan allows a terminated employee to select an
              annuity?
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.annuitization_yesno">
              <roe-radio-input
                v-model="formData.annuitization_yesno"
              ></roe-radio-input>
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
        <div class="form-row-devider"></div>

        <div class="form-row form-row--center-small">
          <div class="form-unit">
            <div class="common-label">
              Indicate the cash-out amount for the plan:
            </div>
          </div>
          <div class="form-unit">
            <roe-error-message :field="$v.formData.cash_out_rule_size">
              <input
                type="number"
                v-model="formData.cash_out_rule_size"
                name="cash_out_rule_size"
                min="1"
                max="5000"
                required
              />
            </roe-error-message>
          </div>
          <div class="form-unit"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";

import { mapMutations } from "vuex";
import { SET_INVALID_FORM_STATE } from "@/store/mutations.type";
import { required, minValue, maxValue } from "vuelidate/lib/validators";

export default {
  name: "RoeDistributionsForm",
  props: ["formData"],
  created() {
    this.setNextButtonState({ isInvalid: this.$v.$invalid });
  },
  watch: {
    "$v.$invalid": function(value) {
      this.setNextButtonState({ isInvalid: value });
    }
  },
  validations() {
    return {
      formData: {
        partial_distributions_yesno: { required },
        installment_payments_yesno: { required },
        annuitization_yesno: { required },
        cash_out_rule_size: {
          required,
          minValue: minValue(1),
          maxValue: maxValue(5000),
          currency: true
        }
      }
    };
  },
  components: {
    RoeErrorMessage,
    RoeRadioInput
  },
  methods: {
    ...mapMutations({
      setNextButtonState: SET_INVALID_FORM_STATE
    })
  }
};
</script>
